import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import {
  Button,
  TablePagination,
  Paper,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableFooter,
  Collapse,
  ButtonGroup,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import CustomDatePicker from "../../commons/CustomDatePicker";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCtmdocs, getOrganizationData, postSync } from "./../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

export default function Ctmdocs() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const location = useLocation();
  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getCtmdocs);
  const filter = convertQueryStringToObject(location.search);

  const [input, setInput] = useState({
    organization: null,
    tntxNo: filter.tntxNo || "",
    exp_date: filter.exp_date || "",
  });
  // state
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, organization_id: input.organization?.id, organization: null, tntxNo: input.tntxNo }));
  };
  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN TỜ KHAI HẢI QUAN"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "customdocs" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getOrganizationData({ status: 1 })}
            value={input.organization || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, organization: newValue }))}
            label={t("Tổ chức")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, organization: option.find((item) => item.id == filter.organization_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.organization_id]}
          />
          <TextField
            label={t("Số tờ khai")}
            value={input.tntxNo || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, tntxNo: e.target.value || null }))}
            style={{ margin: "5px" }}
            InputProps={{ style: { minWidth: "200px" } }}
          />
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Ngày hết hạn")}
            value={input.exp_date}
            onChange={(value) => setInput((prev) => ({ ...prev, exp_date: value }))}
            sx={{ margin: "5px", width: 200 }}
          />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {!loading ? (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      STT
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Số tờ khai")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Mô tả")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Tổ chức")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Lượng tổng")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Lượng phân tách")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Lượng bán")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Ngày hết hạn")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Trạng thái")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.tntxNo}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.declarations}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.org_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.kg?.toLocaleString() || ""}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.AssignedMT?.toLocaleString() || ""}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.capacity?.toLocaleString() || ""}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.exp_date && moment(item.exp_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {t(item.status)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          ) : (
            <div align="center" style={{ width: "100%" }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
